// src/pages/CompletedProjects.jsx
import React from 'react';
import PropertyListingPage from '../PropertyListing/PropertyListing';
import { Helmet } from 'react-helmet';

const UpcomingProjects = () => {
  return(
    <>      <Helmet>
        <title>Upcoming Projects</title>
        <meta name="description" content="Welcome to Gladious – experts in sustainable and modern construction projects." />
      </Helmet>
     <PropertyListingPage filterType="upcoming" pageTitle="Upcoming Projects" />;
  </>
  )
};

export default UpcomingProjects;
